import { render } from "./BuyZoneContainer.vue?vue&type=template&id=15b50c47"
import script from "./BuyZoneContainer.vue?vue&type=script&lang=js"
export * from "./BuyZoneContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__